export const AGGREGATE_POWER_REVIEWS_PRODUCT_ID = 'everlywell-all-products';
export const AGGREGATE_POWER_REVIEWS_PRODUCT_NAME = 'Everlywell Customers';
